import { ComponentStyleConfig } from '@chakra-ui/react';
import { getColorVar, SystemStyleObject } from '@chakra-ui/theme-tools';

import { textStyles } from '../../common';
import { createVariables } from '../../../util';

const variables = createVariables<'bg' | 'stroke' | 'glow' | 'icon'>();

export const CheckboxStyles: ComponentStyleConfig = {
  parts: ['container', 'control', 'icon', 'label'],
  baseStyle: (props) => {
    const containerDisabled: SystemStyleObject = {
      cursor: 'not-allowed',
    };

    const controlDisabled: SystemStyleObject = {
      [variables.bg]: getColorVar(props.theme, 'button.gray'),
      [variables.stroke]: getColorVar(props.theme, 'button.gray.outline'),
      [variables.icon]: getColorVar(props.theme, 'state.disabled'),
      [variables.glow]: 'transparent',
      opacity: 0.5,
      '&& svg': {
        transform: 'none',
      },
    };

    return {
      container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [variables.bg]: getColorVar(props.theme, 'button.gray'),
        [variables.stroke]: getColorVar(props.theme, 'button.gray.outline'),
        [variables.glow]: 'transparent',
        [variables.icon]: 'transparent',
        _hover: {
          [variables.bg]: getColorVar(props.theme, 'button.gray.hover'),
        },
        _active: {
          [variables.bg]: getColorVar(props.theme, 'button.gray.active'),
        },
        _checked: {
          [variables.glow]: getColorVar(props.theme, 'state.selected'),
          [variables.icon]: getColorVar(props.theme, 'state.selected'),
        },
        _disabled: containerDisabled,
        '&:has([data-readonly])': containerDisabled,
        _invalid: {
          '&&': {
            [variables.stroke]: getColorVar(props.theme, 'button.red.outline'),
          },
          _checked: {
            [variables.glow]: getColorVar(props.theme, 'state.error'),
            [variables.icon]: getColorVar(props.theme, 'button.red'),
          },
        },
      },
      control: {
        border: '1px solid',
        outline: '2px solid transparent',
        outlineOffset: '1px',
        '&&&&': {
          color: `var(${variables.icon})`,
        },
        '&&&': {
          background: `var(${variables.bg})`,
          backgroundImage: `radial-gradient(75% 125% at right center, color-mix(in srgb, var(${variables.glow}) 38%, transparent), transparent 45%)`,
          borderColor: `var(${variables.stroke})`,
          boxShadow: 'none',
        },
        _focusVisible: {
          outlineColor: 'state.selected',
        },
        _readOnly: controlDisabled,
        _disabled: controlDisabled,
      },
      icon: {
        width: '12px',
        height: '10px',
      },
      label: {
        '&&': {
          opacity: 1,
        },
        _disabled: {
          color: 'text.disabled',
        },
      },
    };
  },
  sizes: {
    sm: {
      control: {
        width: 3.5,
        height: 3.5,
      },
      label: {
        ...textStyles['body-sm'],
      },
    },
    md: {
      control: {
        borderWidth: '1px',
        width: 4.5,
        height: 4.5,
      },
      label: {
        ...textStyles['body-md'],
      },
    },
    lg: {
      control: {
        width: 5.5,
        height: 5.5,
      },
      label: {
        ...textStyles['body-md'],
      },
    },
  },
  defaultProps: {
    colorScheme: 'blue',
  },
};
